import { useMutation } from '@libs/use';

import * as API from '../requests';

type RegisterReceiptFormModel = {
  receiptNumber: string;
  depositedDate: string;
  brokerAccount: { value: number };
  amountDepositedValue: number;
  imageSrc: string;
  source: number | null;
};

function depositReceiptFactory(formModel: RegisterReceiptFormModel) {
  return {
    trackingNumber: formModel.receiptNumber,
    depositedDate: formModel.depositedDate,
    sourceAccountId: formModel.brokerAccount.value,
    depositValue: formModel.amountDepositedValue,
    attachment: formModel.imageSrc,
    source: formModel.source,
  };
}

export default function useRegisterDepositReceiptQuery({
  onSuccess,
  onReject,
}) {
  const {
    execute: registerDepositReceipt,
    isPending: isRegisterDepositReceipt,
    ...query
  } = useMutation(
    ({ formModel }: { formModel: RegisterReceiptFormModel }) =>
      API.registerDepositReceipt(depositReceiptFactory(formModel)),
    {
      onSuccess,
      onReject,
    }
  );

  return { registerDepositReceipt, isRegisterDepositReceipt, ...query };
}
